import $ from 'jquery';

function getuuid() {
  let s = [];
  let hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-';

  let uuid = s.join('');
  return uuid;
}

function setChildHeight(swiper) {
  swiper.el.style.removeProperty('--childHeight');
  swiper.slides.forEach(el => {
    let childHeight = el.firstElementChild.offsetHeight;
    let cssVarChildHeight = swiper.el.style.getPropertyValue('--childHeight') || 0;
    if (parseInt(cssVarChildHeight) < childHeight) {
      swiper.el.style.setProperty('--childHeight', childHeight + 'px');
    }
  });
}

const swiperGirdInit = (swiper, opt) => {
  const $swiper = $(swiper.el);
  if (swiper.scrollbar.el) $swiper.addClass('como-section-swiper--scrollbar');
  if (opt?.grid?.rows) swiper.el.style.setProperty('--rows', opt?.grid?.rows);
  /* if (opt.breakpoints) {
    for (let [bp, { grid }] of Object.entries(opt.breakpoints)) {
      bp = bp > 800 ? 'lg' : 'md';
      let rows = grid?.rows || opt.grid.rows;
      swiper.el.style.setProperty(`--rows-${bp}`, rows);
    }
  } */

  setTimeout(() => {
    setChildHeight(swiper);
  }, 100);
};

$.fn.swiper = function (opt) {
  this.each(function () {
    let $this = $(this);
    if ($this.data('swiper')) return;
    const $swiperSlide = $this.find('.swiper-slide');
    const { pagination, navigation, scrollbar } = opt;
    let uuid;
    if ($swiperSlide.length > 1) {
      uuid = getuuid();
      this.innerHTML += `
    ${
      pagination
        ? `<div class="${pagination.el.substring(
            1,
            this.lenght,
          )} swiper-pagination swiper-pagination-${uuid}"></div>`
        : ''
    }
    ${
      navigation
        ? `
    <div class="${navigation.nextEl.substring(
      1,
      this.lenght,
    )} swiper-button-next swiper-next-${uuid}"></div>
    <div class="${navigation.prevEl.substring(
      1,
      this.lenght,
    )} swiper-button-prev swiper-prev-${uuid}"></div>`
        : ''
    }
    ${
      scrollbar
        ? `<div class="${scrollbar.el.substring(
            1,
            this.lenght,
          )} swiper-scrollbar swiper-scrollbar-${uuid}"></div>`
        : ''
    }`;
    }
    if (navigation) {
      opt.navigation.nextEl = '.swiper-next-' + uuid;
      opt.navigation.prevEl = '.swiper-prev-' + uuid;
    }
    if (pagination) {
      opt.pagination.el = '.swiper-pagination-' + uuid;
    }
    if (scrollbar) {
      opt.scrollbar.el = '.swiper-scrollbar-' + uuid;
    }

    let defOpt = {
      on: {
        init(swiper) {
          if (opt.pagination) swiper.params.pagination.clickable = true;
          setTimeout(() => {
            if (opt.slidesPerColumn || opt.grid) {
              swiperGirdInit(swiper, opt);
            }
            const $swiper = $(swiper.el);
            if (opt._insertWrap) {
              $swiper.wrap('<div class="swiper-overflow-wrap"></div>');
            }
          });
          opt?.on?.init && opt.on.init.call(swiper, swiper);
        },
        resize(swiper) {
          if (opt.slidesPerColumn || opt.grid) {
            setChildHeight(swiper);
          }
        },
      },
    };
    let mergerOpt = {};
    $.extend(true, mergerOpt, opt, defOpt);

    $this.data('swiper', new Swiper(this, mergerOpt));
    if (navigation && navigation.outside) {
      $this.after($this.find(navigation.nextEl));
      $this.after($this.find(navigation.prevEl));
    }
  });
};
